import { Component, input } from '@angular/core';

@Component({
    selector: 'ach-payer-address',
    templateUrl: 'ach-payer-address.component.html',
    styleUrls: ['ach-payer-address.component.scss'],
    standalone: false
})
export class AchPayerAddressComponent {
  readonly payer = input<string | null>(null);
}
